import { CircularProgress, Menu, MenuItem, Stack, Typography } from '@mui/material';
import { useAsyncAction } from 'app/services';
import { transportGroupLoad } from 'app/store/transport';
import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';

const TransportMenu = (props) => {
  const { open, onClose, onChange, anchorEl } = props;
  const { groupItems } = useSelector((state) => state.transport);

  const { asyncAction: fetchData, isLoading: isFetchLoading } = useAsyncAction(transportGroupLoad);

  const sortItems = useMemo(() => {
    const compareFn = (a, b) => a.name.localeCompare(b.name, { sensitivity: 'base' });

    return groupItems.sort(compareFn);
  }, [groupItems]);

  useEffect(() => {
    if (open) {
      fetchData();
    }
  }, [open]);

  return (
    <Menu
      open={open}
      onClose={onClose}
      anchorEl={anchorEl}
      PaperProps={{
        sx: (theme) => ({
          width: '200px',
          height: '200px',
          overflow: 'auto',
          marginTop: theme.spacing(1.5),
          '&:before': {
            right: '10px',
          },
        }),
      }}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}>
      {isFetchLoading && (
        <Stack
          direction='column'
          alignItems='center'
          justifyContent='center'
          sx={{
            width: '100%',
            height: '155px',
          }}>
          <CircularProgress size={20} />
        </Stack>
      )}
      {!isFetchLoading && !groupItems.length && (
        <Stack
          direction='column'
          alignItems='center'
          justifyContent='center'
          sx={{
            marginTop: '35px',
            width: '100%',
            height: '100%',
            padding: '5px',
          }}>
          <Typography align='center' variant='body1' component='div'>
            Здесь пока ничего нет
          </Typography>
          <Typography align='center' color='text.secondary' variant='caption' component='div'>
            В этом списке будут отображаться группы транспортных средств
          </Typography>
        </Stack>
      )}
      {!isFetchLoading &&
        sortItems.map((value, key) => (
          <MenuItem key={key} disableRipple onClick={() => onChange(value.id)}>
            {value.name}
          </MenuItem>
        ))}
    </Menu>
  );
};

export default TransportMenu;
